import { render, staticRenderFns } from "./TrashButton.vue?vue&type=template&id=1ec79f3a&scoped=true&"
import script from "./TrashButton.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TrashButton.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./TrashButton.vue?vue&type=style&index=0&id=1ec79f3a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec79f3a",
  null
  
)

export default component.exports